import $ from 'jquery';
export default {
	name: 'modal-upload-resultat',
	components: {},
	props: {
		analyse: Object,
		demande: Object,
	},
	data() {
		return {
			files: [],
			import_loading: false,
			patient_nom: '',

            sv_loading: false,
			btn_disable: false,
            result_to_fill: {
                demande_id: 0,
                interpretation: '',
                result_analyse: null
            },

			one_is_empty: false,
			both_is_empty: false,
			is_error: false
		}
	},

	watch: {
		demande() {
			this.patient_nom = (this.demande != null)?this.demande.patient:''
		}
	},

	computed: {
		
	},

	mounted() {
		
	},
	methods: {
		handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.result_to_fill.result_analyse = this.files[0];
			this.clearAll()
		},

		saveResultat() {
			let comment_is_empty = false,
				file_is_empty = false

			if (this.result_to_fill.interpretation == '') {
				comment_is_empty = true
			}

			if (this.result_to_fill.result_analyse == null) {
				file_is_empty = true
			}

			var confirm = document.getElementById('cfrm-result');
			

			if (comment_is_empty && file_is_empty) {
				this.sv_loading = false
				this.btn_disable = false
				this.both_is_empty = true

				return
			} else if (
				( (!comment_is_empty && file_is_empty) || (comment_is_empty && !file_is_empty) ) && 
				(!confirm || confirm.checked == false)
			) {
				this.sv_loading = false
				this.btn_disable = false
				this.one_is_empty = true
				if (confirm && confirm.checked == false) {
					$('.err-msg').fadeIn(500)
				}

				return
			} 

			let max_file_size = 1024
			if (!file_is_empty) {
				if (!this.fileValidation(max_file_size, 'files')) {
					return
				}
			}

			this.sv_loading = true
			this.btn_disable = true

            let data = {
                demande_id: this.demande.id,
                commentaire: this.result_to_fill.interpretation,
                result_analyse: this.result_to_fill.result_analyse
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

			

            this.$store.dispatch('saveAnalyseResult', form_data).then((response) => {
				console.log("RESPONSE: ",response)
                if (response > 0) {
                    this.successMsg("Résultat enregistré avec succès")
					this.$emit('emitListePatientAttente')

					this.result_to_fill ={
						demande_id: 0,
						interpretation: '',
						result_analyse: null
					}
					this.files = []
					this.clearAll()

                    $('.modal').modal('hide')
					
                    
                } else {
                    this.errorMsg('Une erreur est survenue! Merci de réessayer.')
                }
				this.sv_loading = false
				this.btn_disable = false
            }).catch(() => {
				this.is_error = true
                this.sv_loading = false
            })
        },

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

		errorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-danger',
                type: 'danger',
                position: 'top-center'

            })
        },

		/**
         * Cache le message d'erreur au click du checkbox
         */
		onConfirm() {
            $('.err-msg').fadeOut(500);
        },

		clearAll() {
			this.both_is_empty = false 
			this.one_is_empty = false
			this.is_error = false
			$('.err-msg').fadeOut(500)
			$('.err-fsize').fadeOut(500)
			$('.err-extension').fadeOut(500)
		}

		// handleFilesUpload() {
		// 	let uploadedFiles = this.$refs.files.files;
		// 	/*
		// 		Adds the uploaded file to the files array
		// 	*/
		// 	this.files = []
		// 	for (var i = 0; i < uploadedFiles.length; i++) {
		// 		this.files.push(uploadedFiles[i]);
		// 	}
		// },
		// importResultat() {
		// 	this.import_loading = true
		// 	let formData = new FormData();
		// 	$('.err-msg').fadeOut()

		// 	let err = 0

		// 	if (this.files.length == 0) {
		// 		err++
		// 	}

		// 	if (err == 0) {
		// 		formData.append('resultat_fichier', this.files[0],'resultat');
				
		// 		this.$store.dispatch("importResultat", { 'id': this.demande.id, 'data': formData }).then(() => {
		// 		this.import_loading = false
		// 		// après le rendu sur la page, faire disparaitre le modal
		// 		this.files = []

		// 		this.$refs.exitModal.click()

		// 		this.$store.dispatch("getRegistre", this.analyse.abreviation).then(
		// 			() => {
		// 			console.log('coucou')
		// 			}
		// 		)
		// 		this.doSuccessMessage();


		// 		}, error => {
		// 		if (error.response) {
		// 			// this.doErrorMsg("Erreur d'enregistrement")
		// 			console.log("Erreur Import")
		// 			this.import_loading = false
		// 		}

		// 		});
		// 	} else {
		// 		// TODO::: Afficher un message informant l'utilisateur de choisir un fichier
		// 		$('.err-msg').fadeIn(500)
		// 		this.import_loading = false
		// 	}
		// },

		// doSuccessMessage: function () {
		// 	this.$toasted.show('Le fichier du résultat a été importé avec succès', {
		// 		duration: 3000,
		// 		action: [
		// 		{
		// 			text: 'X',
		// 			onClick: (e, toastObject) => {
		// 			toastObject.goAway(0);
		// 			}
		// 		}
		// 		],
		// 		theme: 'toasted-primary',
		// 		type: 'success',
		// 		position: 'top-center'

		// 	})
		// },
	}
}


